<template>
  <div class="base-chip">
    <slot>
      <base-text light size="s">
        {{ label|truncate(truncate) }}
      </base-text>
    </slot>
    <slot name="icon">
      <base-icon class="base-chip__icon" :icon="icon" @click="$emit('delete')" />
    </slot>
  </div>
</template>

<script>
export default {
  name: 'BaseChip',
  props: {
    /**
       * @description
       * The label of the chip, it can be overridden by the default slot.
    */
    label: {
      type: String,
      default: 'Label',
    },
    /**
       * @description
       * icon of the chip, it can be overridden by the icon slot.
    */
    icon: {
      type: String,
      default: 'close-small',
    },
    /**
     * @description
     * Truncate the label to the given length
     */
    truncate: {
      type: Number,
      default: 50,
    },
  },
};
</script>

<style lang="scss" scoped>
.base-chip{
    display: inline-flex;
    padding-left: 0.4rem;
    padding-right: 0.4rem;
    column-gap: 7px; // Yes, we can use column-gap here!.
    height: 20px;
    align-items: center;
    vertical-align: middle;
    border: solid 1px rgba($black, 0.25);

    @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
        /* Retina-specific stuff here */
        border: none;
        box-shadow: inset 0px 0px 0px 0.25px $black;
    }
}
.base-chip:hover{
  border: solid 1px transparent;
  background-color: #F0B78A;
}
</style>
